import {
  FComptetUser,
  FLivraisonInterface,
  UserInterface,
} from "../interfaces/UserInterface";
import {
  ALL_COUNTRIES_DELIVERY,
  CT_CONTROLENC_COMPTE_BLOQUE,
  EN_CPTE_SANS_BDC,
} from "../utils/UserUtils";
import { RootState, store } from "../app/store";
import { FPaysInterface } from "../interfaces/FPaysInterface";
import { USER_BON_DE_COMMANDE, USER_EN_COMPTE } from "../app/globalSlice";

export const isUserBonDeCommande = (
  user: UserInterface | undefined
): boolean => {
  if (user === undefined || user.modeDeCommande === undefined) {
    return false;
  }
  return USER_BON_DE_COMMANDE.includes(user.modeDeCommande);
};

export const isUserEnCompte = (user: UserInterface | undefined): boolean => {
  if (user === undefined || user.modeDeCommande === undefined) {
    return false;
  }
  return USER_EN_COMPTE.includes(user.modeDeCommande);
};

export const getMainLivraison = (): FLivraisonInterface | undefined => {
  const state: RootState = store.getState();
  const livraisons = state.globalState.user?.fLivraisons;
  if (!livraisons || livraisons.length === 0) {
    return undefined;
  }
  let result = livraisons.find((l) => l.liPrincipal === 1);
  if (result) {
    return result;
  }
  return livraisons[0];
};

export const getThisPays = (
  isFacturation: boolean = false
): FPaysInterface[] => {
  const state: RootState = store.getState();
  const fPays = state.globalState.fPays;
  if (isFacturation) {
    return [...(fPays ?? [])];
  }
  return (
    fPays?.filter((fPays) => {
      return ALL_COUNTRIES_DELIVERY.includes(fPays.paIntitule);
    }) ?? []
  );
};

export const userIsBlocked = (user: UserInterface | undefined): boolean => {
  return user?.ctControlenc === CT_CONTROLENC_COMPTE_BLOQUE;
};

export const isFiable = (
  user: UserInterface | FComptetUser | undefined
): boolean => {
  return (
    !!user &&
    ((USER_EN_COMPTE.includes(user.modeDeCommande ?? EN_CPTE_SANS_BDC) &&
      (user.fiable === "1" || user.fiable === "" || user.fiable === null)) ||
      user.fiable === "1")
  );
};

export const getFournisseurName = (ctNum: string): string => {
  const state: RootState = store.getState();
  return (
    state.globalState.fournisseurs?.find((f) => f.userIdentifier === ctNum)
      ?.ctIntitule ?? ""
  );
};
